import { render, staticRenderFns } from "./FormulaOrder.vue?vue&type=template&id=1c15ed94&scoped=true"
import script from "./FormulaOrder.vue?vue&type=script&lang=js"
export * from "./FormulaOrder.vue?vue&type=script&lang=js"
import style0 from "./FormulaOrder.vue?vue&type=style&index=0&id=1c15ed94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c15ed94",
  null
  
)

export default component.exports